




import { pageFactory } from '@/main/pages/pageFactory';
import { pageStoreBuilder } from '@/main/store/pages/page/builder';

const name = 'KampaneListIframe';

export default pageFactory(name, pageStoreBuilder({
	name,
	crumbLabel: 'CRM_Kampane',
	dropdownList: {},
	localState: {},
	props: {
		mode: null,
	},
}));
